var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "afs5d74f8sdqf74",
    x1: 16.5,
    x2: 21.5,
    y1: 19.67,
    y2: 28.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fbbf24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b463fq4sd5f4sq5f4sqfsq",
    x1: 22.56,
    x2: 39.2,
    y1: 21.96,
    y2: 50.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#f3f7fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeafb"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 24,
    r: 5,
    fill: "url(#afs5d74f8sdqf74)",
    stroke: "#f8af18",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fbbf24",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19 15.67V12.5m0 23v-3.17m5.89-14.22l2.24-2.24M10.87 32.13l2.24-2.24m0-11.78l-2.24-2.24m16.26 16.26l-2.24-2.24M7.5 24h3.17m19.83 0h-3.17"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "45s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 19 24; 360 19 24"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b463fq4sd5f4sq5f4sqfsq)",
    stroke: "#e6effc",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    d: "M46.5 31.5h-.32a10.49 10.49 0 00-19.11-8 7 7 0 00-10.57 6 7.21 7.21 0 00.1 1.14A7.5 7.5 0 0018 45.5a4.19 4.19 0 00.5 0v0h28a7 7 0 000-14z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/cloudy.c7b5ab12bc4dcf23058d22166c132d38.svg";
export { ForwardRef as ReactComponent };